import dynamic from 'next/dynamic'

export const DynamicStoreInfoDrawer = dynamic(
  () => import('.').then((mod) => mod.StoreInfoDrawer),
  { ssr: false },
)
